<template>
	<section>
		<form @submit.prevent="validateAndSubmit">
			<input-text v-model="model.subject" name="subject" :placeholder="$t('labels.general.subject')" rules="required"/>
			<input-textarea v-model="model.message" name="message" :placeholder="$t('labels.general.message')" rules="required"/>
			<error-box v-if="form_error" :error="form_error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="loading" icon="send">{{ $t('buttons.general.send') }}</button-submit-icon-text>
			</div>
		</form>
	</section>
</template>

<script>
	export default {
		name: 'new-tickect-form-component',
		data() {
			return {
				loading: false,
				model: {
					subject: '',
					message: ''
				}
			}
		},
		methods: {
			validateAndSubmit () {
				this.$validator.validateAll().then(result => {
					if (result) this.submit()
				})
			},
			submit () {
				this.loading = true
				setTimeout(() => {
					this.loading = false
					this.$emit('completed')
				},1000)
			},
		}
	}
</script>

<style scope></style>


// WEBPACK FOOTER //
// src/components/support/forms/NewTickectFormComponent.vue